import * as types from './_actionTypes';

export const fetchStudentAnalyticsRequest = () => ({
  type: types.FETCH_STUDENT_ANALYTICS_REQUEST
});

export const fetchStudentAnalyticsSuccess = (analytics) => ({
  type: types.FETCH_STUDENT_ANALYTICS_SUCCESS,
  payload: analytics
});

export const fetchStudentAnalyticsFailure = (error) => ({
  type: types.FETCH_STUDENT_ANALYTICS_FAILURE,
  payload: error
});

export const fetchContentPerformanceRequest = () => ({
  type: types.FETCH_CONTENT_PERFORMANCE_REQUEST
});

export const fetchContentPerformanceSuccess = (performance) => ({
  type: types.FETCH_CONTENT_PERFORMANCE_SUCCESS,
  payload: performance
});

export const fetchContentPerformanceFailure = (error) => ({
  type: types.FETCH_CONTENT_PERFORMANCE_FAILURE,
  payload: error
});

export const exportAnalyticsReportRequest = (format) => ({
  type: types.EXPORT_ANALYTICS_REPORT_REQUEST,
  payload: format
});

export const exportAnalyticsReportSuccess = (reportData) => ({
  type: types.EXPORT_ANALYTICS_REPORT_SUCCESS,
  payload: reportData
});

export const exportAnalyticsReportFailure = (error) => ({
  type: types.EXPORT_ANALYTICS_REPORT_FAILURE,
  payload: error
});